var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('ul',_vm._l((_vm.links),function(link,i){return _c('li',{key:i,class:{ last: i === _vm.links.length - 1 }},[(link.path || i === 0)?_c('router-link',{attrs:{"to":link.path || { name: 'home' }}},[_vm._v(" "+_vm._s(link.name)+" ")]):_c('span',[_vm._v(" "+_vm._s(link.name)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }